import { useQuery } from "@apollo/client/react";
import { useContext } from "react";

import { UserContext } from "@/contexts/user-context";
import { AccountExtendedByPublicKeyDocument } from "@/graphql/codegen/graphql";

export const useFetchCurrentAccount = ({
  publicKey,
}: {
  publicKey: string;
}) => {
  const { currentUserPublicKey, refetchUser } = useContext(UserContext);

  const {
    data: fullAccountData,
    refetch,
    loading: accountLoading,
  } = useQuery(AccountExtendedByPublicKeyDocument, {
    variables: {
      publicKey,
    },
  });

  const fetchAccountData = async (publicKey: string) => {
    // TODO: consider making window.location.reload()
    await refetch({
      publicKey,
    });

    if (publicKey === currentUserPublicKey) {
      refetchUser();
    }
  };
  const fullAccount = fullAccountData?.accountByPublicKey;
  const isMyAccount = currentUserPublicKey === publicKey;

  return {
    isMyAccount,
    publicKey,
    fullAccount,
    fetchAccountData,
    accountLoading,
    fullAccountData,
  };
};
